import React from 'react';

const NosMetiersHeader = () => {
  const headerStyle = {
    backgroundColor: '#ffffff',
    color: '#19214f',
    padding: '20px',
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '2.5rem',
    margin: '0',
    fontWeight: 'bold',
  };

  const textStyle = {
    fontSize: '1.2rem',
    marginTop: '10px',
    lineHeight: '1.5',
  };

  return (
    <header id="nos-metiers" style={headerStyle}>
      <h1 style={titleStyle}>Nos métiers</h1>
      <p style={textStyle}>
        Les Voiries Franciliennes proposent une gamme complète de services en travaux publics, génie civil et aménagement paysager.
        Notre expertise technique et notre expérience nous permettent de répondre à tous vos besoins, de la conception à la réalisation de vos projets.
      </p>
    </header>
  );
};

export default NosMetiersHeader;
